<template>
  <transition name="fade-transform" :appear="true">
    <div :class="classObj" class="app-wrapper w-h-100">
      <div
        class="w-100 relative overflow-hidden transition3"
        :style="{ height: shrink ? 0 : '5rem' }"
      >
        <navbar />
      </div>
      <div
        class="mainView flex_row_s transition3"
        :style="{ height: shrink ? '100%' : 'calc(100% - 5rem)' }"
      >
        <div class="screen-container">
          <app-main />
        </div>
      </div>
      <websocketMessage></websocketMessage>
    </div>
  </transition>
</template>

<script>
import { AppMain, Navbar } from './components';
import { mapState } from 'vuex';
import StompService from '@/utils/websocket.js';
import websocketMessage from '@/components/WebsocketBox/message.vue';
export default {
  name: 'Layout',
  components: {
    AppMain,
    Navbar,
    websocketMessage,
  },
  data() {
    return {
      screenWidth: null,
      shrink: false,
      stompService: null,
    };
  },
  created() {
    window.document.documentElement.setAttribute(
      'theme-name',
      'theme-boldDark',
    );
    this.stompService = new StompService('http://10.100.10.60:30132/ws');
    this.stompService.connect();
    this.stompService.subscribe('/topic/event/update', (task) => {
      this.setSessionItem('websocketInform', JSON.stringify(task));
    });
  },
  beforeDestroy() {
    this.stompService?.disconnect();
  },
  computed: {
    ...mapState({
      sidebar: (state) => state.app.sidebar,
    }),
    classObj() {
      return {
        hideSidebar: !this.sidebar.opened,
        openSidebar: this.sidebar.opened,
        withoutAnimation: this.sidebar.withoutAnimation,
        'app-wrapper2': this.$route.path.includes('systemsCooperation'),
      };
    },
  },
  methods: {
    handleShrinkNav() {
      this.shrink = !this.shrink;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/styles/variables.scss';
.app-wrapper {
  background: url('@/assets/screen/bg.png') no-repeat;
  background-size: 100% 100%;
  user-select: none;
}
.app-wrapper2 {
  background: url('@/assets/screen/bg2.png') no-repeat;
  background-size: 100% 100%;
  user-select: none;
}

.transition3 {
  transition: 0.3s;
}
</style>
